<template>
<div class="big">
  <button class="dayin" v-print="'#dayin'" v-on:click="printAndValidate">打印</button>
  <div class="tab" id="dayin">
    <div class="new_title">
      湖南桃江农村商业银行股份有限公司
    </div>
     <!-- {{info.company_name}}
    {{info.exam_name}} -->
    <div class="new_title">2023年公开招聘员工笔试</div>
    <div class="tab_title1 fbold">准考证</div>
    <div class="tab_content frow">
      <div class="tab_left fcolumn">
        <div class="line">姓&nbsp;&nbsp;名：{{info.name}}</div>
        <div class="line">身份证号：<span class="fbold">{{info.cid}}</span></div>
        <div class="line">准考证号：<span class="fbold">{{info.number}}</span></div>
        <div class="line">报考岗位：{{info.post}}</div>
        <div class="line">考 场 号：{{exam.place}}</div>
        <div class="line">座 位 号：{{exam.seat}}</div>
        <div class="line">考试时间：{{exam.time}}</div>
        <div class="line">考试科目：{{exam.subject}}</div>
        <div class="line">考试地点：{{info.address}}</div>
      </div>
      <div class="tab_img">
        <img :src="info.img" mode="widthFix">
      </div>
    </div>
    <div class="i_content" v-html="info.notice">{{info.notice}}</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Search',
  data () {
    return {
      title:'',
      cid:'330206199409033112',
      info:{
        address:'',
        apply_name:'',
        cid:'',
        name:'',
        number:'',
        img:'',
        post:'',
        notice:'',
        number:'',
        exam_name:'',
        company_name:''
      },
      exam:{
        place:'',
        seat:'',
        subject:'',
        time:'',
      }
    }
  },
  methods:{
    getData(){
      var config = {};
      this.$request.get('/api/user/get-ticket', {'cid':this.cid},config, response => {
          if(response.data.code == 200){
            this.info = response.data.data;
            if(response.data.data.exam){
              this.exam = response.data.data.exam[0];
            }
          }
      }, error => {
          console.log(error)
      });
    },
    printAndValidate() {
      var config = {};
      this.$request.get('/api/user/print-ticket', {'cid':this.cid},config, response => {
         if(response.data.code == 200){
            
          }
      }, error => {
          console.log(error)
      });
    },

    
  },
  mounted() {
    
  },
  created(){
    this.cid = this.$route.query.cid;
    this.title = localStorage.getItem('title');
    this.getData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .dayin{
    width:100px;
    height:30px;
    line-height:30px;
    border-radius:5px;
    border:none;
    text-align: center;
    background:#1B8BFB;
    color:white;
    position: fixed;
    right:10px;
    top:5px;
    cursor: pointer;
  }
  .line{
    margin-top:5px;
  }
  .tab{
    width:90%;
    margin:10px auto;
    border:1px solid black;
    height:auto;
    color:#383838;
    padding:10px 0;
    font-family: "宋体";
  }
  .new_title{
    text-align: center;
    font-size:25px;
    line-height:30px;
  }
 .tab_title1{
    font-size:24px;
    margin:15px 0;
    text-align: center;
    font-weight: bold;
 }
 .tab_content{
    width:94%;
    font-size:18px;
    margin:10px auto;
 }
 .tab_left{
    width:72%;
 }
 .tab_line{
    line-height:25px;
 }
 .tab_img{
    width:28%;
    border:1px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:2px;
 }
 .tab_img img{
  width:90%;
 }
 .i_content{
    width:95%;
    margin:60px auto 0;
    text-align: justify;
    font-size:15px;
 }
 .tb{
    border-bottom:1px solid black;
    min-height:35px;
 }
 .tab_c1{
    text-align: center;
    font-size:13px;
    line-height:35px;
    border-right:1px solid black;
    min-width:25%;
 }
 .tab_c2{
    text-align: left;
    font-size:13px;
    padding-left:5px;
    line-height:35px;
 }
 .per_img{
    width:95%;
 }
 .tab_last{
    min-height:40px;
    line-height:25px;
    font-size:13px;
    margin-top:5px;
 }
 .tl_1{
    width:25%;
    text-align: center;
 }
 .tl_2{
    width:45%;
    text-align: center;
 }
 .tl_3{
    width:15%;
    text-align: center;
 }
 .tl_4{
    width:15%;
    text-align: center;
 }

  .index_bottom{
    width:100%;
    height:40px;
    border-top:5px solid #E6E6E6;
    color:#999999;
    font-size:12px;
    /* position: absolute; */
    /* bottom:0; */
    padding:10px 0;
  }
  .bottom_name{
    height:20px;
    line-height:20px;
    text-align: center;
    font-weight: bold;
  }
  .bottom_code{
    height:25px;
    line-height:25px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Ticket.vue